/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Finance {
    @Serenity.Decorators.registerClass()
    export class ServiceInwardDetailsGrid extends _Ext.ItemGridEditor<ServiceInwardDetailsRow> {
        protected getColumnsKey() { return 'Finance.ServiceInwardDetails'; }
        protected getDialogType() { return ServiceInwardDetailsDialog; }
        protected getIdProperty() { return ServiceInwardDetailsRow.idProperty; }
        protected getInsertPermission() { return ServiceInwardDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return ServiceInwardDetailsRow.localTextPrefix; }
        protected getService() { return ServiceInwardDetailsService.baseUrl; }
      

        //#endregion


    }
}